// extracted by mini-css-extract-plugin
export default {"carousel":"GF-z"};